import { getRecordConfigProperties } from '../services/propertiesService';
import { getSessionInfo, getTeacherInfo } from '../services/apiService';
import { getRecordInfoEvent, getRecordPresentationEvent, getRecordWhiteboardEvent, getRecordChatEvent, getRecordVideoEvent, getRecordAudioEvent, getRecordCursorEvent } from '../services/eventService';
import { parsePresentationTimeNodes, filterPresentationTimeNodes } from '../utils/presentationUtils';

export const initRecordDataLoad = async (roomId, callback) => { 

    const initStartTime = Date.now();

    let result = {
        recordEventUrlTemplate: null,
        recordMediaUrlTemplate: null,
        sessionInfo: null,
        teacherInfo: null,
        recordInfo: null,
        presentationInfo: null,
        presentationTimeNodes: [], // 新增：课件时间节点
        whiteboardInfo: null,
        chatInfo: null,
        cursorInfo: null,
        videoInfo: null,
        audioInfo: null
    };

    let errorMessage = "";

    // 第一步：获取配置属性
    try {
        const [recordEventUrlTemplate, recordMediaUrlTemplate] = await getRecordConfigProperties();
        result.recordEventUrlTemplate = recordEventUrlTemplate;
        result.recordMediaUrlTemplate = recordMediaUrlTemplate;
        callback([null, 5, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第二步：获取房间ID
        const sessionInfo = await getSessionInfo(roomId);
        result.sessionInfo = sessionInfo;
        callback([null, 10, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第二步：获取教师信息
        const teacherInfo = await getTeacherInfo(result.sessionInfo?.teacherId);
        if (!teacherInfo) {
            throw new Error('获取教师信息失败!');
        }

        result.teacherInfo = teacherInfo;
        callback([null, 15, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第三步：获取录制基础信息
        const recordInfo = await getRecordInfoEvent(result.recordEventUrlTemplate, roomId, result.sessionInfo?.startTime);
        if(!recordInfo) {
            // 抛出异常
            throw new Error('配置文件不存在！');
        }

        result.recordInfo = recordInfo;
        callback([null, 20, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第四步：获取录制课件事件信息
        const presentationInfo = await getRecordPresentationEvent(result.recordEventUrlTemplate, roomId, result.recordInfo.startTime * 1000, result.sessionInfo?.startTime);
        if(!presentationInfo) {
            // 抛出异常
            throw new Error('课件文件不存在');
        }

        result.presentationInfo = presentationInfo;
        
        // 解析课件时间节点
        const parsedTimeNodes = parsePresentationTimeNodes(presentationInfo);
        
        // 过滤课件时间节点（这里暂时使用一个较大的持续时间，实际值将在播放器中确定）
        result.presentationTimeNodes = parsedTimeNodes;

        console.log('课件时间节点: ', result.presentationTimeNodes);
        
        callback([null, 25, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第五步：获取录制白板事件信息
        const whiteboardInfo = await getRecordWhiteboardEvent(result.recordEventUrlTemplate, roomId, result.recordInfo.startTime * 1000, result.sessionInfo?.startTime);
        if (!whiteboardInfo) {
            // 抛出异常
            throw new Error('白板文件不存在');
        }

        result.whiteboardInfo = whiteboardInfo;
        callback([null, 30, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第六步：获取聊天信息
        const chatInfo = await getRecordChatEvent(result.recordEventUrlTemplate, roomId, result.recordInfo.startTime * 1000, result.sessionInfo?.startTime);
        result.chatInfo = chatInfo;

        callback([null, 35, errorMessage]);
    } catch (err) {
        console.warn(`资源加载异常: ${err.message}`);
    }

    try {
        // 第七步：获取录制白板事件信息
        const audioInfo = await getRecordAudioEvent(result.recordEventUrlTemplate, result.recordMediaUrlTemplate, roomId, result.sessionInfo?.startTime);
        if (!audioInfo) {
            throw new Error('音频文件不存在');
        }

        result.audioInfo = audioInfo;
        callback([null, 40, errorMessage]);
    } catch (err) {
        errorMessage = `资源加载异常: ${err.message}`;
        callback([null, null, errorMessage]);
        return;
    }

    try {
        // 第八步：获取录制白板事件信息
        const videoInfo = await getRecordVideoEvent(result.recordEventUrlTemplate, result.recordMediaUrlTemplate, roomId, result.sessionInfo?.startTime);
        result.videoInfo = videoInfo;

        callback([null, 45, errorMessage]);
    } catch (err) {
        console.warn(`资源加载异常: ${err.message}`);
    }

    
    try {
        // 第九步：获取魔棒信息
        const cursorInfo = await getRecordCursorEvent(result.recordEventUrlTemplate, roomId, result.recordInfo.startTime * 1000, result.sessionInfo?.startTime);

        // console.log('魔棒信息: ', cursorInfo);

        result.cursorInfo = cursorInfo;

        callback([null, 60, errorMessage]);
    } catch (err) {
        console.info(`资源加载异常: ${err.message}`);
    }

    const initEndTime = Date.now();

    // 判断一下，如果初始化时间小于3秒，则再阻塞一下，凑足3秒
    const remainingTime = 3000 - (initEndTime - initStartTime);

    if (remainingTime > 0) {
        const startTime = Date.now();
        while (Date.now() - startTime < remainingTime) {
            // 计算当前进度（65% -> 100%）
            const elapsed = Date.now() - startTime;

            const progress = Math.min(65 + Math.round((35 * elapsed) / remainingTime), 100);

            if(progress % 5 === 0) {
                callback([null, progress, null])
            }

            await new Promise(resolve => setTimeout(resolve, 50)); // 50ms 更新一次，避免卡顿
        }
    }

    callback([null, 100, errorMessage]);

    // 延迟500ms
    await new Promise(resolve => setTimeout(resolve, 500));

    callback([result, null, errorMessage]);
};
